import Dexie, { Table } from 'dexie';
import type { ProductionCycle } from '../types';

export class BroilerDatabase extends Dexie {
  cycles!: Table<ProductionCycle, string>;

  constructor() {
    super('BroilerAccountingDB');
    
    this.version(1).stores({
      cycles: 'id, timestamp',
    });
  }
}

export const db = new BroilerDatabase();
